import * as React from 'react';
import { fetchApi, JsonResponse } from '../../services/api';
import LoadingPanel from '../LoadingPanel';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { IDName } from '../Accounts/Payments';
import { NumericTextBox } from '@progress/kendo-react-inputs';

type Props = {
  Link: ApiLink;
  CloseDialog: () => void;
  RefreshSchedule: () => void;
}

type State = {
    isLoading: boolean;
    studentCourseId: number;
    course: CourseData | null;
    teachers: IDName[];
    schools: IDName[];
}

type CourseData = {
    StudentCourseId: number;
    TeacherName: string;
    MidtermGrade: number;
    FinalGrade: number;
    CourseName: string;
    CourseCode: string;
    AcademicYear: string;
    GradeTaken: number;
    SemesterTaken: number;
    Period: number;
    SchoolId: number;
    TeacherId: number;
    Notes: string;
}

export class CourseEditModal extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            course: null,
            isLoading: false,
            studentCourseId: 0,
            teachers: [],
            schools: [],
        };

        this.save = this.save.bind(this);
        this.updateState = this.updateState.bind(this);
    }

    public componentWillMount() {
        this.setState({ isLoading: true });
        fetchApi(this.props.Link.Href, {}, this.props.Link.Method)
            .then((response: { StudentCourseId: number, Course: CourseData, Teachers: IDName[], Schools: IDName[] }) => {
                this.setState({ course: response.Course, studentCourseId: response.StudentCourseId, teachers: response.Teachers, schools: response.Schools });
                this.setState({ isLoading: false });
            });
    }

    public render() {
        const grades = [
            {ID: 0, Name: "Kindergarten"},
            {ID: 1, Name: "1"},
            {ID: 2, Name: "2"},
            {ID: 3, Name: "3"},
            {ID: 4, Name: "4"},
            {ID: 5, Name: "5"},
            {ID: 6, Name: "6"},
            {ID: 7, Name: "7"},
            {ID: 8, Name: "8"},
            {ID: 9, Name: "9"},
            {ID: 10, Name: "10"},
            {ID: 11, Name: "11"},
            {ID: 12, Name: "12"}
        ];
        const years = [
            {ID: 3, Name: "2020-2021"},
            {ID: 2, Name: "2019-2020"},
            {ID: 1, Name: "2018-2019"},
            {ID: 0, Name: "2017-2018"}
        ];
        const semesters = [
            {ID: 0, Name: "Semester One"},
            {ID: 1, Name: "Semester Two"},
            {ID: 2, Name: "Summer"},
            {ID: 3, Name: "Full Year"}
        ];
        const periods = [
            {ID: 1, Name: "First"},
            {ID: 2, Name: "Second"},
            {ID: 3, Name: "Third"},
            {ID: 4, Name: "Fourth"},
            {ID: 5, Name: "Five"},
            {ID: 6, Name: "Six"},
            {ID: 7, Name: "Seven"},
            {ID: 8, Name: "Eight"},
            {ID: 9, Name: "After Hours"}
        ];
        return (<React.Fragment>
            <div className="k-overlay" style={{ zIndex: 10002, opacity: 0.5 }} />
            <div role="dialog"
                className="k-widget k-window k-dialog"
                style={{ maxWidth: '90%', left: 0, right: 0, margin: '0 auto' }}>
            {this.state.isLoading && <LoadingPanel />}
            {this.state.course &&
                <div className="k-window-titlebar k-dialog-titlebar k-header">
                    <span className="k-window-title k-dialog-title">Edit Course - {this.state.course.CourseCode} - {this.state.course.CourseName}</span>
                    <div className="k-window-actions k-dialog-actions">
                        <a
                        role="button"
                        href="#"
                        className="k-button k-bare k-button-icon k-window-action k-dialog-action k-dialog-close"
                        title="Close"
                        aria-label="Close"
                        onClick={(e) => {
                        this.props.CloseDialog();
                        e.preventDefault();
                        }}>
                            <span className="k-icon k-i-close" />
                        </a>
                    </div>
                </div>}
                {this.state.course &&
                <div data-role="dialog" className="k-content k-window-content k-dialog-content">
                    <div className="k-form">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">School Taken At</span>
                            </div>
                            <DropDownList
                                textField="Name"
                                className="form-control"
                                data={this.state.schools}
                                value={this.state.schools.find(x => x.ID == this.state.course.SchoolId)}
                                onChange={(e) => { this.onChangeSchool(e.target.value.ID) }}
                            />
                        </div>
                        <div className="input-group" style={{ margin: "5px 0 0 0" }}>
                            <div className="input-group-prepend">
                                <span className="input-group-text">Teacher</span>
                            </div>
                            <DropDownList
                                textField="Name"
                                className="form-control"
                                data={this.state.teachers}
                                value={this.state.teachers.find(x => x.ID == this.state.course.TeacherId)}
                                onChange={(e) => { this.updateState({ TeacherId: e.target.value.ID })}}
                            />
                        </div>
                        <div className="input-group" style={{ margin: "5px 0 0 0" }}>
                            <div className="input-group-prepend">
                                <span className="input-group-text">Academic Year Taken</span>
                            </div>
                            <DropDownList
                                textField="Name"
                                className="form-control"
                                data={years}
                                value={years.find(x => x.Name == this.state.course.AcademicYear)}
                                onChange={(e) => { this.updateState({ AcademicYear: e.target.value.Name })}}
                            />
                        </div>
                        <div className="input-group" style={{ margin: "5px 0 0 0" }}>
                            <div className="input-group-prepend">
                                <span className="input-group-text">Semester Taken</span>
                            </div>
                            <DropDownList
                                textField="Name"
                                className="form-control"
                                data={semesters}
                                value={semesters.find(x => x.ID == this.state.course.SemesterTaken)}
                                onChange={(e) => { this.updateState({ SemesterTaken: e.target.value.ID })}}
                            />
                        </div>
                        <div className="input-group" style={{ margin: "5px 0 0 0" }}>
                            <div className="input-group-prepend">
                                <span className="input-group-text">Period</span>
                            </div>
                            <DropDownList
                                textField="Name"
                                className="form-control"
                                data={periods}
                                value={periods.find(x => x.ID == this.state.course.Period)}
                                onChange={(e) => { this.updateState({ Period: e.target.value.ID })}}
                            />
                        </div>
                        <div className="input-group" style={{ margin: "5px 0 0 0" }}>
                            <div className="input-group-prepend">
                                <span className="input-group-text">Grade Taken</span>
                            </div>
                            <DropDownList
                                textField="Name"
                                className="form-control"
                                data={grades}
                                value={grades.find(x => x.ID == this.state.course.GradeTaken)}
                                onChange={(e) => { this.updateState({ GradeTaken: e.target.value.ID })}}
                            />
                        </div>
                        <div className="input-group" style={{ margin: "5px 0 0 0" }}>
                            <div className="input-group-prepend">
                                <span className="input-group-text">Midterm Grade</span>
                            </div>
                            <NumericTextBox
                                placeholder="Midterm Grade"
                                onChange={(e) => { this.updateState({ MidtermGrade: e.target.value })}}
                                value={this.state.course.MidtermGrade}
                                max={100}
                                min={0}
                                step={1}
                            />
                            <div className="input-group-prepend">
                                <span className="input-group-text">Final Grade</span>
                            </div>
                            <NumericTextBox
                                placeholder="Final Grade"
                                onChange={(e) => { this.updateState({ FinalGrade: e.target.value })}}
                                value={this.state.course.FinalGrade}
                                max={100}
                                min={0}
                                step={1}
                            />
                        </div>
                        <div className="input-group" style={{ margin: "5px 0 0 0" }}>
                            <div className="input-group-prepend">
                                <span className="input-group-text">Notes</span>
                            </div>
                            <input
                                className="form-control"
                                type="text"
                                name={`Notes`}
                                placeholder="Notes"
                                value={this.state.course.Notes}
                                onChange={(e) => this.updateState({ Notes: e.target.value })} />
                        </div>
                    </div>
                    </div>}
                    <div className="k-button-group k-dialog-buttongroup k-dialog-button-layout-stretched" role="toolbar">
                    <button
                        type="button"
                        className="k-button"
                        style={{ width: '50%' }}
                        onClick={(e) => {
                                this.props.CloseDialog();
                                e.preventDefault();
                            }}
                        >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="k-button k-primary"
                        style={{ width: '50%' }}
                        onClick={this.save}
                        >
                        Save
                    </button>
                </div>
            </div>
        </React.Fragment>
        );
    }

    private onChangeSchool(schoolId: number) {
        this.updateState({ SchoolId: schoolId });
        fetchApi(`api/Teacher/GetTeachersAtSchool/${schoolId}`)
            .then((teachers: IDName[]) => {
                this.setState({ teachers: teachers })
            });
    }

    private updateState(value: Partial<CourseData>) {
        const course = Object.assign({}, this.state.course, value);
        this.setState({ course });
    }

    private save() {
        if (this.state.course) {
            const data = {
                StudentCourseId: this.state.course.StudentCourseId,
                MidtermGrade: this.state.course.MidtermGrade,
                FinalGrade: this.state.course.FinalGrade,
                AcademicYear: this.state.course.AcademicYear,
                GradeTaken: this.state.course.GradeTaken,
                SemesterTaken: this.state.course.SemesterTaken,
                Period: this.state.course.Period,
                SchoolId: this.state.course.SchoolId,
                TeacherId: this.state.course.TeacherId,
                Notes: this.state.course.Notes
            };

            this.setState({ isLoading: true })
            fetchApi("api/Course/Update", data, "POST")
                .then((response: JsonResponse) => {
                    if (response.Success) {
                        this.props.RefreshSchedule();
                        this.props.CloseDialog();
                    } else {
                        alert(response.ErrorMessage);
                    }
                }).catch(() => {
                    alert("Unknown Error Occurred!");
                }).finally(() => {
                    this.setState({ isLoading: false });
                });
        }
    }
}
